import { render, staticRenderFns } from "./MerchantSupportVisitationList.vue?vue&type=template&id=6ffbfb86&scoped=true&"
import script from "./MerchantSupportVisitationList.vue?vue&type=script&lang=js&"
export * from "./MerchantSupportVisitationList.vue?vue&type=script&lang=js&"
import style0 from "./MerchantSupportVisitationList.vue?vue&type=style&index=0&id=6ffbfb86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffbfb86",
  null
  
)

export default component.exports